import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Page from "../../components/general/page";
import PreCogPage from "../../components/preCog";

const PreCogView = ({ pageRef }) => {

  const [isFromBankPayments, setIsFromBankPayments] = useState(false);

  const location = useLocation();

  useEffect(() => {    
    setIsFromBankPayments(location.state?.isFromBankPayments ? true : false);
  }, [location.state?.isFromBankPayments]);
    
  /**
   * BEGIN TODO: da rimuovere postDemo. Per capire se voglio o meno header e sidebar
   */
  const embedParameter = new URLSearchParams(location.search).get("embed");
  /**
     * END TODO: da rimuovere postDemo
     */
     
  return (
    <Page
      pageRef={pageRef}
      title={"Prima nota"}      
      activePage="/preCog"
      className={"contentStructure " + (embedParameter === "" ? "embed" : "")}
    >
      
      <PreCogPage pageRef={pageRef} isFromBankPayments={isFromBankPayments} />
    </Page>
  );
};

export default PreCogView;
